export default __webpack_public_path__ + "static/media/solar-pv.ad977106.jpeg";